import type { TypeLang } from '@/schema'

export const getDictionary = async (locale:TypeLang) => {
  const base = await import(`./dictionaries/base/${locale}.json`).then(module => module.default)

  const project = await import(`./dictionaries/project/${locale}.json`).then(module => module.default)
  return { ...base, ...project }
}
